import { useMediaQuery } from '@mui/material';
/**
 * Returns true if browser window width is less than 900px. Same as `theme.breakpoints.down('md')`.
 * Used by `GlobalApp` to control menu and pinned bar visibility.
 *
 * @returns {boolean} `true` if screen width is below the 'md' breakpoint, otherwise `false`.
 */
export function useSmallOrMediumDevice() {
    return useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true });
}
